import styled from '@emotion/styled';
import { Grid } from '@naf/grid';
import { breakpoints } from '@naf/theme';

export const StyledGrid = styled(Grid)`
  position: relative;
  z-index: 10;
  margin-top: -150px;

  @media (max-width: ${breakpoints.m}) {
    margin-top: -60px;
  }
`;
